import { render, staticRenderFns } from "./DuplicatedContact.vue?vue&type=template&id=7adf7a6a&"
import script from "./DuplicatedContact.vue?vue&type=script&lang=js&"
export * from "./DuplicatedContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports